import { render, staticRenderFns } from "./URLShortener.vue?vue&type=template&id=402cb80e&"
import script from "./URLShortener.vue?vue&type=script&lang=js&"
export * from "./URLShortener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports